import React from 'react';
import { Input, Button } from '@crisellevaldez/speculo-ui';
import { Search, RotateCw, PlusCircle } from 'lucide-react';

interface ClientAdminTableHeaderProps {
  searchQuery: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRefresh: () => Promise<void>;
  onAddOrganization: () => void;
  isLoading: boolean;
  totalClients: number;
}

export const ClientAdminTableHeader: React.FC<ClientAdminTableHeaderProps> = ({
  searchQuery,
  onSearchChange,
  onRefresh,
  onAddOrganization,
  isLoading,
  totalClients,
}) => {
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1">
        <Input
          placeholder="Search organizations..."
          startIcon={<Search className="text-gray-400" size={20} />}
          value={searchQuery}
          onChange={onSearchChange}
          className="w-full"
        />
      </div>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          className="p-2 justify-center"
          onClick={onRefresh}
          disabled={isLoading}
        >
          <RotateCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
        </Button>
        <Button
          variant="secondary"
          size="sm"
          className="p-2 justify-center !bg-green-600 hover:bg-green-500 text-white"
          onClick={onAddOrganization}
        >
          <PlusCircle className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
